// React
import React from 'react';
import {inject, observer} from 'mobx-react';

// WS
import {getBoolVariation, LD_FLAGS} from 'modules/feature-flags';
import {Routes as SharedRoutes} from 'components/Routes';
import {NotFound} from 'components/NotFound';
import {withRouter} from 'components/withRouter';
import {IdleTimer} from 'components/IdleTimer';
import {LoadingIndicator} from 'components/shared/LoadingIndicator';
import RootStore from 'mobx/RootStore';
import PublicFrame from 'pages/Public';
import ResetFrame from 'pages/Reset';
import JoinFrame from 'pages/Join';
import {AuthorizedFrame} from 'pages/AuthorizedFrame';
import {MaintenanceMode} from '../MaintenanceMode/MaintenanceMode';

export const routes = [
  {
    Component: PublicFrame,
    isProtected: false,
    path: '/auth/*',
  },
  {
    Component: ResetFrame,
    isProtected: false,
    path: '/reset-password',
  },
  {
    Component: JoinFrame,
    isProtected: false,
    path: '/join/*',
  },
  {
    Component: AuthorizedFrame,
    isProtected: true,
    path: '/*',
  },
  {
    Component: NotFound,
    isProtected: false,
    path: '*',
  },
];

class PageContainer extends React.Component {
  state = {
    events: {},
  };

  async componentDidMount() {
    const {router, tutorialStore} = this.props;

    tutorialStore.setRouter(router);

    await RootStore.getInstance().init();
  }

  render() {
    if (this.props.appStore.apiMaintenanceMode) {
      return <MaintenanceMode />;
    }

    const showLoader =
      this.props.meStore.isSigningOut || !RootStore.getInstance().isReady;

    const isLocalEnvironment = process.env.REACT_APP_ENV === 'local';

    // Imperative read — won't reactively re-render if the flag flips,
    // but re-evaluated on each render
    const useIdleTimer =
      !isLocalEnvironment &&
      this.props.meStore.isAuthenticated() &&
      getBoolVariation(LD_FLAGS.SECURITY_IDLE_TIMER);

    return (
      <div style={styles.pageContent}>
        {useIdleTimer && <IdleTimer />}
        {showLoader ? (
          <LoadingIndicator stylesOverride={styles.loaderContainer} />
        ) : (
          <SharedRoutes routes={routes} />
        )}
      </div>
    );
  }
}
const styles = {
  pageContent: {
    flexGrow: 1,
    display: 'flex',
  },
  loaderContainer: {
    width: '100%',
    flexGrow: 1,
  },
};

export default withRouter(
  inject('meStore', 'tutorialStore', 'appStore')(observer(PageContainer)),
);
